import request from '@/utils/request'
/**
 *
 * 用户管理
 *
 **/
// 登录
export const login = (data: any) =>
  request({
    'url': '/admin/user/login',
    'method': 'post',
    data
  })
  // 退出
 export const userLogout = (params: any) =>
 request({
   'url': `/admin/user/logout`,
   'method': 'post',
   params
 })

export const getEmployeeList = (params: any) => {
  // 修正参数格式，确保查询参数正确
  const queryParams = {
    page: params.page || 1,
    pageSize: params.pageSize || 10,
    username: params.username || '', // 用户名/姓名
    phone: params.phone || '',
    openid: params.openid || '', // 微信用户唯一标识/账号
    status: params.status
  }
  
  return request({
    url: '/admin/user/page',
    method: 'get',
    params: queryParams
  })
}

// 修改---启用禁用接口
export const enableOrDisableEmployee = (params: any) => {
  return request({
    url: `/admin/user/status/${params.status}`,
    method: 'post',
    params: { id:params.id }
  })
}

// 新增---添加用户
export const addEmployee = (params: any) => {
  return request({
    url: '/admin/user',
    method: 'post',
    data: { ...params }
  })
}

// 修改---添加用户
export const editEmployee = (params: any) => {
  return request({
    url: '/admin/user',
    method: 'put',
    data: { ...params }
  })
}

// 修改页面反查详情接口
export const queryEmployeeById = (id: string | (string | null)[]) => {
  return request({
    url: `/admin/user/${id}`,
    method: 'get'
  })
}

// 删除用户
export const deleteEmployee = (id: string) => {
  return request({
    url: `/admin/user/${id}`,
    method: 'delete'
  })
}

// 获取所有可用用户列表
export const getAllActiveUsers = () => {
  return request({
    url: '/admin/user/list',
    method: 'get'
  })
}
